import React from 'react';
import { useNavigate } from "react-router-dom";
import Text from '../../main/Text';
import Line from '../../main/Line';
import { GrClose } from "react-icons/gr";

const TransferFinish = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <Line type="bottom-line" style={{ flexDirection: "row-reverse" }} >
        <GrClose style={{ cursor: "pointer" }} onClick={() => {
          navigate('/home')
        }} />
      </Line>
      <Text >
        transfer completed. the new owner will receive an email with instructions on how to access the authenticity portal.
      </Text>
    </>
  )
}

export default TransferFinish;
